// components/StatusChip.jsx
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Chip, Menu, MenuItem } from "@mui/material";
import { STATUS_TAG_STYLES } from "../../constants/constants";

export default function StatusChip({
                                       status,
                                       label = "",
                                       clickable = false,
                                       onStatusChange,
                                       availableStatuses = Object.keys(STATUS_TAG_STYLES),
                                       chipBorderRadius = "18px",
                                       chipHeight = "25px"
                                   }) {
    const [anchorEl, setAnchorEl] = useState(null);

    const style = STATUS_TAG_STYLES[status] || { bg: "#e9ecef", color: "#344767" };

    const handleClick = (event) => {
        if (clickable) {
            event.stopPropagation();
            setAnchorEl(event.currentTarget);
        } 
    };

    const handleClose = () => setAnchorEl(null);

    const handleSelect = (newStatus) => {
        handleClose();
        if (onStatusChange) onStatusChange(newStatus);
    };

    return (
        <>
            <Chip
                label={label ? label : status?.replace("_", " ")}
                size="small"
                clickable={clickable}
                onClick={handleClick}
                sx={{
                    backgroundColor: style.bg,
                    color: style.color,
                    fontWeight: "bold",
                    textTransform: "capitalize",
                    borderRadius: chipBorderRadius,
                    height:chipHeight
                }}
            />

            {clickable && (
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    {availableStatuses.map((s) => {
                        const st = STATUS_TAG_STYLES[s] || { bg: "#E0E0E0", color: "#424242" };
                        return (
                            <MenuItem
                                key={s}
                                onClick={() => handleSelect(s)}
                                sx={{ color: st.color, fontWeight: "bold" }}
                            >
                                {s.replace("_", " ")}
                            </MenuItem>
                        );
                    })}
                </Menu>
            )}
        </>
    );
}

StatusChip.propTypes = {
    status: PropTypes.string.isRequired,
    label: PropTypes.string,
    chipBorderRadius: PropTypes.string,
    chipHeight: PropTypes.string,
    clickable: PropTypes.bool,
    onStatusChange: PropTypes.func,
    availableStatuses: PropTypes.arrayOf(PropTypes.string),
};
